import DateTime from "../../lib/dateTime.js"
import ExtraPricingModel from "./extraPricingModel.js"
import PricingModel from "./pricingModel.js"

export default class ClubCalendarView {
	id = null
	clubId = null
	year = 0
	pricing = null
	published = false
	
	regularEvents = {}
	specialEvents = {}

	get allEvents() {
		let events = Object.entries(this.regularEvents).map(([id, e]) => ({
			id: id,
			sort: e.occurrsOn.valueOf(),
			name: e.occurrsOn.format('dd MMM yyyy'),
			date: e.occurrsOn.format('dd MMM yyyy'),
			startsOn: e.occurrsOn,
			endsOn: e.occurrsOn,
			notes: e.notes,
			status: e.status,
			statusNotes: e.statusNotes,
			type: 'regular'
		}))

		events = events.concat(Object.entries(this.specialEvents).map(([id, e]) => ({
			id: id,
			sort: e.startsOn.valueOf(),
			date: e.startsOn.format('dd MMM yyyy') + ' - ' + e.endsOn.format('dd MMM yyyy'),
			startsOn: e.startsOn,
			endsOn: e.endsOn,
			name: e.name,
			notes: e.notes,
			status: e.status,
			statusNotes: e.statusNotes,
			type: 'special'
		})))

		events.sort((a, b) => a.sort - b.sort)

		return events;
	}

	get futureEvents() {
		let events = this.allEvents;
		return events.filter(e => e.startsOn >= DateTime.today);
	}

	constructor()
	{
		this.pricing = new PricingModel();
	}

	getEvent(eventId)
	{
		return this.allEvents.find(e => e.id == eventId);
	}

	static RegularEvent = class {
		id = null
		occurrsOn = null
		notes = null
		status = 'planned'
		statusNotes = null
	}

	static SpecialEvent = class {
		id = null
		startsOn = null
		endsOn = null
		name = null

		notes = null

		status = 'planned'
		statusNotes = null

		pricingExtras = null

		constructor()
		{
			this.pricingExtras = new ExtraPricingModel();
		}
	}
}